import { useGameController } from "./shell/hooks/useGameController.js";
import { HomeScreen } from "./screens/HomeScreen.js";
import { BriefScreen } from "./screens/BriefScreen.js";
import { EditorScreen } from "./screens/EditorScreen.js";
import { CompareScreen } from "./screens/CompareScreen.js";
import { RecapScreen } from "./screens/RecapScreen.js";
import { PortfolioScreen } from "./screens/PortfolioScreen.js";
import { RoadmapScreen } from "./screens/RoadmapScreen.js";
import { ChallengeLandingScreen } from "./screens/ChallengeLandingScreen.js";
import { ChallengeInvalidScreen } from "./screens/ChallengeInvalidScreen.js";
import { PhoneFrame } from "./shell/ui/PhoneFrame.js";
import { InstallHint } from "./shell/ui/InstallHint.js";
import "./shell/styles/desk.css";

export function App() {
  const game = useGameController();
  const { state } = game;

  const screen = (() => {
    switch (state.screen) {
      case "home":
        return <HomeScreen game={game} />;
      case "brief":
        return <BriefScreen game={game} />;
      case "editor":
        return <EditorScreen game={game} />;
      case "compare":
        return <CompareScreen game={game} />;
      case "recap":
        return <RecapScreen game={game} />;
      case "portfolio":
        return <PortfolioScreen game={game} />;
      case "roadmap":
        return <RoadmapScreen game={game} />;
      case "challenge-landing":
        return <ChallengeLandingScreen game={game} />;
      case "challenge-invalid":
        return <ChallengeInvalidScreen game={game} />;
      default:
        return <HomeScreen game={game} />;
    }
  })();

  return (
    <>
      <PhoneFrame>{screen}</PhoneFrame>
      <InstallHint />
    </>
  );
}
